/**
 * Environment configuration for the Campaign Dashboard
 * Provides environment-specific settings and feature flags
 */

// Environment detection
const isStaging = process.env.REACT_APP_ENVIRONMENT === 'staging';
const isDev = process.env.NODE_ENV === 'development';

// Feature flags
const useNewTwitterService = process.env.USE_NEW_TWITTER_SERVICE !== 'false';

/**
 * Environment-specific configuration
 */
export const config = {
 // Environment info
 environment: process.env.REACT_APP_ENVIRONMENT || 'development',
 
 // API configuration
 apiBaseUrl: process.env.REACT_APP_API_URL || 'http://localhost:9000',
 socketUrl: process.env.REACT_APP_SOCKET_URL || 'http://localhost:9000',
 
 // Authentication settings
 requireExplicitAuth: isStaging, // Staging requires explicit auth headers
 
 // Default headers
 defaultHeaders: {
 'Content-Type': 'application/json',
 'x-api-key': process.env.REACT_APP_API_KEY || ''
 },
 
 // Timeout settings
 timeouts: {
 apiRequest: isDev ? 30000 : 60000, // Longer timeouts in staging
 socketConnection: isDev ? 10000 : 30000
 },
 
 // Feature flags
 features: {
 useNewTwitterService,
 enableRecurringCampaigns: true,
 enableConsolidatedMetrics: true
 },
 
 // Logging
 logging: {
 enableVerboseLogging: isDev,
 logNetworkRequests: isDev,
 logWebSocketEvents: isDev
 }
};

/**
 * Get the appropriate API URL based on the current environment
 * @param {string} endpoint - The API endpoint
 * @returns {string} The full API URL
 */
export const getApiUrl = (endpoint) => {
 // Ensure endpoint starts with a slash
 const formattedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
 
 // Don't add /api prefix - it's handled by the gateway
 return `${config.apiBaseUrl}${formattedEndpoint}`;
};

/**
 * Get environment-specific logging function
 * @param {string} level - Log level (log, warn, error, info)
 * @returns {Function} Logging function that respects environment settings
 */
export const getLogger = (level = 'log') => {
 return (...args) => {
 if (config.logging.enableVerboseLogging || level === 'error') {
 console[level](`[${config.environment}]`, ...args);
 }
 };
};

export default config;
